"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/divider/style");
var _divider = _interopRequireDefault(require("antd/lib/divider"));
var _react = _interopRequireDefault(require("react"));
var _PatientInfoItem = require("../../PatientInfoItem");
var _utils = require("../../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EmergencyContact = function EmergencyContact(props) {
  var contact = props.contact,
    showDivider = props.showDivider;
  var firstName = contact.firstName,
    lastName = contact.lastName,
    phoneNumber = contact.phoneNumber,
    relationship = contact.relationship;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showDivider && /*#__PURE__*/_react.default.createElement(_divider.default, null), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Name:",
    value: (0, _utils.composeName)([firstName, lastName])
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Phone:",
    value: phoneNumber
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Relationship:",
    value: relationship
  }));
};
var _default = EmergencyContact;
exports.default = _default;